import { CLOSE_EVALUATION } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (termNumber: string, token: string) =>
  fetch(CLOSE_EVALUATION(termNumber), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }).then(errorHandler)
